<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hKFjq6/tc-custom/9781035817313.jpg?1728169182737" alt="This image is the cover for the book La Metisse"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">La Metisse
      </h1>
      <p class="bookDescription body article font2">
        <p>Elizabeth’s tale begins in the colonial embrace of British India, 1936, where she was cradled in privilege and steeped in Christian tradition. At nineteen, she veered from the path expected of her, embarking on a bohemian chapter that defied her upbringing. Yet, the winds of change ushered in a period of stability when she married her soulmate. Embracing the joys and challenges of motherhood, Elizabeth raised eight children, overturning the preconceived notion ingrained since childhood that she would never work. Her life’s journey defied expectations, from a teenager’s rebellion to a dedication to family and work that spanned from the tender age of 16 to the seasoned age of 70.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cassiopaeiae
      </h2>
      
      <p class="authorDescription body article">Born in British India during the Raj, Cassiopaeiae was brought up by her maternal aunt and this book is a tribute to her “two” mothers: her natural mother and her aunt, whom she always called Mamma.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?83073c5c